<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid p-3" v-bind:id="getId()">
    <div class="row mt-0" v-if="teamid == 0">
      <div class="col custom-form-main-label">
        {{$store.translate('add_team')}}
      </div>
    </div>
    <div class="row mt-0" v-if="teamid != 0">
      <div class="col custom-form-main-label">
        {{$store.translate('manage_team')}}
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <form class="login-formx form-validate" action="index.html" onsubmit="return false" id="createTeamForm">
          <div class="row mt-3">
            <div class="col-lg-12 custom-form-label">
              {{$store.translate('team')}}
            </div>
          </div>
          <div class="form-group row mt-1">
            <div class="col-lg-12">
              <input required v-model="teamname" type="text" id="txtteamname" v-bind:placeholder="$store.translate('team')" maxlength="200" name="name" class="form-control" />
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-lg-12 custom-form-label">
              {{$t('email')}}
            </div>
          </div>
          <div class="form-group row mt-1">
            <div class="col-lg-12">
              <input v-model="email" type="email" id="txtemail" v-bind:placeholder="$t('email')" maxlength="200" name="email" class="form-control" />
            </div>
          </div>
          <div class="form-group row mt-3">
            <div class="col-lg-12 text-right">
              <button @click="saveteam" type="submit" class="btn skin primary-button mt-1"><i class="icon-cog5 mr-2"></i> {{$t('save')}}</button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="row m-0 p-0 mt-3" v-if="isEdit == true">
      <div class="col p-0 m-0">
        <table class="table">
          <tr><td class="custom-form-label" style="padding-left:0px !important;">{{$store.translate('team_members')}} </td><td align="right">{{teamMembers.length}}</td></tr>
          <tr v-for="option in teamMembers" class="mt-1">
            <td align="left" style="padding-left:0px !important;">{{ option.FullName }}</td>
            <td align="right"><a @click="deleteTeamMember(option.Id)"><i class="icon-user-minus"></i></a></td>
          </tr>
        </table>
      </div>

    </div>
    <div class="row mt-3">
      <add-teammember-selector v-if="isEdit == true" @event-refresh-teammembers="loadTeamMembers" ref="teamSelector"></add-teammember-selector>
    </div>
  </div>
</template>

<script>



  import TeamMemberSelector from './add-teammember-selector.vue'
  var teamMembers = [];
  var teamid = 0;

  export default {
    name: "manage-team",
    components: {
      TeamMemberSelector
    },
    props: {
      enableedit: {
        required: false,
        type: String,
        default: "false"
      },
      type: {
        required: false,
        type: String,
        default: ""
      }
    },
    data() {
      return {
        teamMembers,
        teamid: 0,
        isEdit: false,
        teamname: '',
        email: "",
      };
    },

    methods: {
      clearFields() {
        this.teamname = '';
        this.email = '';
      },
      getId() {
        return "child_" + this._uid;
      },
      toggleActivation() {

      },
      handleRefresh(val) {
        this.$forceUpdate();
      },
      removeMe() {
        this.$emit('remove', this.getId());
      },

      async loadTeamMembers() {
          try {
            this.teams = [];
            this.$http.get(`/api/Teams/v1/Members/${this.teamid}`).then(async response => {
              this.teamMembers = response.data;
              Vue.set(this, "teamMembers", this.teamMembers);
              this.$forceUpdate();
              
              if (this.$refs.teamSelector != undefined && this.teamid != undefined) {
                this.$refs.teamSelector.teamId = this.teamid;
              }
            });
          } catch (err) {
            alert('some error:' + err)
            if (this.$refs.teamSelector != undefined && this.teamid != undefined) {
              this.$refs.teamSelector.teamId = this.teamid;
            }
          }        
      },
      async deleteTeamMember(id) {
        try {
          this.$http.delete(`/api/Teams/v1/Members/${id}`).then(async response => {
            this.loadTeamMembers();
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      async getTeam(teamId) {
        try {
          if (teamId > 0) {
            this.$http.get(`/api/Teams/v1/${teamId}`).then(async response => {
              var team = response.data;
              this.teamname = team.Name;
              this.email = team.Email;

            });
          }
        } catch (err) {
          alert('some error:' + err)
        }
      },
      async saveteam() {
        if (!$('#createTeamForm').valid())
          return false;
        this.OrganisationId = $('#select_assigned_Organisation_' + this.getId()).val();
        var request = { teamid: this.teamid, name: this.teamname, email: this.email };

        try {
          var response = await this.$http.post(
            '/api/Teams/v1',
            request
          ).then(async response => {
            this.clearFields();
            vm.$root.$emit('refreshview');
          })

        } catch (err) {

        }
      },
    },
    computed: {

    },
    mounted() {
      _componentValidation('#createTeamForm');
      if (this.teamid > 0) {
        this.getTeam(this.teamid);
      }
    },

    created: function () {

    },

    watch: {
      teamid: function (newVal, oldVal) {
        this.teamname = '';
        this.email = '';
        this.loadTeamMembers();
        this.getTeam(newVal);
      },
    },
    created() {
    },
  };

</script>

<style scoped>
  .table {
    color: inherit;
  }

  .table td {
    padding: 10px !important;
    padding-top: 5px;
    border-bottom: 1px solid #ddd;
    border-top: 0px solid #ddd;
    margin-right: 10px;
    
  }
</style>



// WEBPACK FOOTER //
// src/components/team/manage-team.vue